import { patients } from "./patients";
import {
  SearchCriteria,
  SearchResultRow,
} from "../../api/search-metadata.types";

const normalize = (s?: string | null) => (s ?? "").trim().toLowerCase();
const digitsOnly = (s?: string | null) => (s ?? "").replace(/\D/g, "");

export const searchPatients = (criteria: SearchCriteria): SearchResultRow[] => {
  const first = normalize(criteria.firstName);
  const last = normalize(criteria.lastName);
  const dob = (criteria.dateOfBirth ?? "").trim();
  const mrn = (criteria.mrn ?? "").trim();
  const ssn = digitsOnly(criteria.ssn);
  const phone = digitsOnly(criteria.phone);
  const address = normalize(criteria.address);

  return patients.filter((p) => {
    if (first && !p.firstName.toLowerCase().includes(first)) return false;
    if (last && !p.lastName.toLowerCase().includes(last)) return false;
    if (dob && p.dateOfBirth !== dob) return false;
    if (mrn && (p.medicalRecordNumber ?? "") !== mrn) return false;
    if (ssn && digitsOnly(p.ssn) !== ssn) return false;
    if (phone && digitsOnly(p.phone) !== phone) return false;
    if (address && !normalize(p.address).includes(address)) return false;
    return true;
  });
};
